// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__zdqQ8","image":"Header_image__2s5Sr","name":"Header_name__1Av5N","info":"Header_info__1YjBA","infoRow":"Header_infoRow__1ZchL"};